var gumshoe = require('../vendor/gumshoe');

export class ScrollspyNavbar {
    constructor() {
        if (document.querySelector(".scrollspy-navbar")) {
            let navbarContainer = document.querySelectorAll('.scrollspy-navbar')[0];
            let jumpToTop = navbarContainer.querySelectorAll('.top-trigger')[0];

            jumpToTop.addEventListener("click", function(e){
                e.preventDefault();

                if (history.pushState) {
                    history.pushState(null, null, '#top');
                } else {
                    location.hash = '#top';
                }
                
                window.scrollTo(0, 0);
            });

            // Find all sections to add to scrollspy nav list
            const jumpSections = Array.prototype.slice.call(document.querySelectorAll('[data-scrollspy="true"]'));
            let jumpList = '';

            // Create list item by looping through each section
            jumpSections.forEach(section => {
                let sectionTitle = section.getAttribute('data-scrollspy-title');
                let sectionTarget = section.id;

                jumpList += `<li><a href="#${sectionTarget}">${sectionTitle}</a></li>`;
            });

            // Add string of list items to scrollspy nav
            const jumpListContainer = navbarContainer.querySelectorAll('nav ul')[0];
            jumpListContainer.innerHTML = jumpList;

            // Handler when the DOM is fully loaded
            document.addEventListener("DOMContentLoaded", function(){
                gumshoe.init({
                    selector: '[data-gumshoe] a', // Default link selector (must use a valid CSS selector)
                    selectorHeader: '#siteHeader', // Fixed header selector (must use a valid CSS selector)
                    container: window, // The element to spy on scrolling in (must be a valid DOM Node)
                    offset: 250, // Distance in pixels to offset calculations
                    activeClass: 'active', // Class to apply to active navigation link and its parent list item
                    scrollDelay: false // Wait until scrolling has stopped before updating the navigation
                });
            });

            const footer = document.querySelector(".site-container > .footer");
            const siteContainer = document.querySelector('.site-container');
            const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            let lastScrollTop = 0;

            // Handle sticky offset when hitting footer
            window.addEventListener("scroll", () =>
                window.requestAnimationFrame(() => {
                    var currentPos = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

                    // get offset of footer
                    let footerOffset = footer.getBoundingClientRect().top + window.scrollY;

                    // handle scrolspy navbar sticky
                    if (currentPos > (footerOffset - viewHeight)) {
                        // downscroll code
                        navbarContainer.classList.add('sticky-bottom');
                    } else {
                        navbarContainer.classList.remove('sticky-bottom');
                    }

                    // set current position to lastScrollTop
                    lastScrollTop = currentPos;
                })
            );
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/scrollspy-navbar.ts